import { Button, Typography, withForm } from '@stern-ui/ui';
import { Close, PlusCircleOutline } from 'mdi-material-ui';

import { contactFilterOptions, contactTypeFilterOptions } from '@/utils/filterOptions';

import { contactFiltersDefaultObj } from '../../../utils';

import { patientListFiltersFormOptions } from './patientListFiltersFormOptions';
import { PatientListFiltersFormSection } from './PatientListFiltersFormSection';

export const PatientListFiltersContact = withForm({
	...patientListFiltersFormOptions,
	render: ({ form }) => {
		return (
			<PatientListFiltersFormSection
				title='Contact filters'
				dataTestId='filters-contact-section'
			>
				<>
					<form.Field name='contact_filters' mode='array'>
						{(field) => (
							<div>
								{(field.state.value || []).map((_contact_filter, index) => (
									<div
										key={index}
										className='grid grid-cols md:grid-cols-3 gap-4 md:gap-8 pb-4 items-start border border-secondaryBorder md:border-none px-4 md:px-0 mb-4'
									>
										<div className='flex items-end'>
											<div className='pb-3 pr-6'>
												<Typography>Patient</Typography>
											</div>
											<div className='grow'>
												<form.AppField
													name={`contact_filters[${index}].is_null`}
												>
													{(field) => (
														<field.SelectField
															label="Has/doesn't have"
															labelClassName='invisible'
															options={contactFilterOptions}
														/>
													)}
												</form.AppField>
											</div>
										</div>
										<div className='flex items-end'>
											<div className='grow'>
												<form.AppField
													name={`contact_filters[${index}].name`}
												>
													{(field) => (
														<field.SelectField
															label='Contact type'
															options={contactTypeFilterOptions}
														/>
													)}
												</form.AppField>
											</div>
											<div className='pb-1 pl-4'>
												<Button
													variant='icon'
													size='icon'
													className='px-0 py-0 text-secondaryTextDark'
													onClick={() => field.removeValue(index)}
													title='Close'
												>
													<Close className='w-3 h-3' />
												</Button>
											</div>
										</div>
									</div>
								))}
								<div className='-ml-2 pb-2'>
									<Button
										variant='icon'
										size='icon'
										className='px-0 py-0 text-primaryBrand'
										onClick={() => field.pushValue(contactFiltersDefaultObj)}
										title='Add'
									>
										<PlusCircleOutline className='w-4 h-4' />
										<span className='text-secondaryTextDark pl-2 inline-block pt-px align-top'>
											Add
										</span>
									</Button>
								</div>
							</div>
						)}
					</form.Field>
				</>
			</PatientListFiltersFormSection>
		);
	},
});
